import React, { useState } from 'react';
import {
  Box, Typography, TextField, Grid, Button, FormControl, InputLabel,
  Select, MenuItem, Card, CardContent, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'; 
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const Reports = () => {
  const [vendor, setVendor] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleVendorChange = (e) => setVendor(e.target.value);

  const vendors = ['Vendor A', 'Vendor B', 'Vendor C'];

  const dummyPowerData = [
    { id: 1, date: '2025-05-01', vendor: 'Vendor A', power: '120 kWh', cost: '$15.00' },
    { id: 2, date: '2025-05-02', vendor: 'Vendor B', power: '90 kWh', cost: '$11.25' },
  ];

  const dummyPortsData = [
    { id: 1, date: '2025-05-01', vendor: 'Vendor A', ports: 5, time: '3h', cost: '$30.00' },
    { id: 2, date: '2025-05-02', vendor: 'Vendor B', ports: 3, time: '2h', cost: '$18.00' },
  ];

  const dummyTransactionData = [
    { id: 1, vendor: 'Vendor A', transactions: 20, revenue: '$200.00', discount: '$20.00', final: '$180.00' },
    { id: 2, vendor: 'Vendor B', transactions: 15, revenue: '$150.00', discount: '$10.00', final: '$140.00' },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ color: "black", fontWeight: 'bold' }}>
        Vendor Reports
      </Typography>
      <Typography variant="body2" sx={{ color: 'gray', marginBottom: 1 }}>
        Last Updated: {new Date().toLocaleDateString()}
      </Typography>

      <Grid
        container
        spacing={0.5}
        sx={{ mb: 1 }}
        alignItems="center"
        justifyContent="flex-end"
        wrap="nowrap"
      >
        {/* Search Field */}
        <Grid item>
          <TextField
            id="outlined-size-small"
            label="Search"
            variant="outlined"
            size="small"
            fullWidth
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: 'gray', mr: 1 }} />,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
              },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel>Select Vendor</InputLabel>
            <Select sx={{ width: "180px" }} value={vendor} onChange={handleVendorChange} label="Select Vendor">
              {vendors.map((v) => (
                <MenuItem key={v} value={v}>{v}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} md={2}>
          <DatePicker
            sx={{
              width: "180px"
            }}
            label="From"
            value={fromDate}
            onChange={(newDate) => setFromDate(newDate)}
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <DatePicker
            sx={{
              width: "180px"
            }}
            label="To"
            value={toDate}
            onChange={(newDate) => setToDate(newDate)}
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />
        </Grid>

        <Grid item>
          <Button
            size="small"
          >
            Export
          </Button>
        </Grid>
      </Grid>

      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          {/* Section 1 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
            Daily Power Consumption Report
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                  <TableCell>Date</TableCell>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Power Consumed</TableCell>
                  <TableCell>Cost</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dummyPowerData.map((row, idx) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.vendor}</TableCell>
                    <TableCell>{row.power}</TableCell>
                    <TableCell>{row.cost}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Section 2 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            No of Ports Used
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                  <TableCell>Date</TableCell>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>No of Ports Used</TableCell>
                  <TableCell>Usage Time</TableCell>
                  <TableCell>Cost</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dummyPortsData.map((row, idx) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.vendor}</TableCell>
                    <TableCell>{row.ports}</TableCell>
                    <TableCell>{row.time}</TableCell>
                    <TableCell>{row.cost}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Section 3 */}
          <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 1 }}>
            Transaction Summary Report
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Total Transactions</TableCell>
                  <TableCell>Total Revenue</TableCell>
                  <TableCell>Discount Given</TableCell>
                  <TableCell>Final Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dummyTransactionData.map((row, idx) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.vendor}</TableCell>
                    <TableCell>{row.transactions}</TableCell>
                    <TableCell>{row.revenue}</TableCell>
                    <TableCell>{row.discount}</TableCell>
                    <TableCell>{row.final}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Reports;